import { env } from '~publish/env'

export function getMcpServerUrl(): string {
  return env.VITE_MCP_SERVER_URL
}
